import apiClient from './apiClient';

export const toggleFollow = async (userId, authorId) => {
  const response = await apiClient.post('/api/author-follows/toggle', { userId, authorId });
  return response.data;
};

export const getFollowStatus = async (userId, authorId) => {
  const response = await apiClient.get('/api/author-follows/status', {
    params: { userId, authorId },
  });
  return response.data;
};

export const getFollowingCount = async (userId) => {
  const response = await apiClient.get(`/api/author-follows/following/${userId}`);
  return response.data;
};

export const getFollowerCount = async (authorId) => {
  const response = await apiClient.get(`/api/author-follows/followers/${authorId}`);
  return response.data;
};

export const getFollowedAuthorsFeed = async (userId) => {
  const response = await apiClient.get(`/api/author-follows/feed/${userId}`);
  return response.data;
};
